import { BaseFetch } from "../main-model"
export default class ReportTempleModel extends BaseFetch {
    getReportTempleBy = (data) =>
    this.authFetch({
      url: "report-temple/getReportTempleBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
